// @ts-nocheck 870944aa
import _ from 'lodash';
import addPanelDataConsts from '#packages/addPanelDataConsts';
import triggerBiEvent from './triggerElementAddedBiEvent';
import * as addPanelAddCompService from '../addPanelAddCompService';
import constants from '../../constants/constants';
import superAppsConstants from '../../superApps/superAppsConstants';

const APP_DEF_ID = superAppsConstants.NEW_BLOG_APP_DEF_ID;
const WIDGET_ID = '2f3d2c69-2bc4-4519-bd72-0a63dd92577f';

const BI_PARAMS = {
  element_type: 'archive',
};

const onClick = function (
  compStructure,
  sectionTitle,
  tags,
  itemId,
  editorAPI,
  addOptions,
) {
  triggerBiEvent(editorAPI, BI_PARAMS);
  return addPanelAddCompService.addCompOnClick(
    editorAPI,
    APP_DEF_ID,
    WIDGET_ID,
    compStructure,
    tags,
    itemId,
    { origin: constants.BI.type.ADD_WIDGET },
    addOptions,
  );
};

const onDrop = function (layoutParams, compPreset, parentComponent, editorAPI) {
  triggerBiEvent(editorAPI, BI_PARAMS);
  return addPanelAddCompService.addCompOnDrop(
    editorAPI,
    APP_DEF_ID,
    WIDGET_ID,
    layoutParams,
    compPreset,
    parentComponent,
    _.noop,
    { origin: constants.BI.type.ADD_WIDGET },
  );
};

function getSection() {
  return {
    type: addPanelDataConsts.SECTIONS_TYPES.PRESET,
    hide: false,
    title: 'add_section_label_newblog_archive',
    subNavigationTitle: 'add_section_label_newblog_archive',
    presetTitle: 'add_section_label_newblog_archive',
    tooltipTitle: 'add_section_label_newblog_archive',
    automationId: 'add-panel-section-newBlog-archive',
    sectionName: 'archiveSection',
    subNavigationHide: false,
    showSectionHeader: true,
    additionalBehaviours: {
      labelMode: addPanelDataConsts.LABEL_BEHAVIOUR.NONE,
      infoIcon: addPanelDataConsts.INFO_ICON_BEHAVIOUR.NONE,
      hoverImageAction: addPanelDataConsts.HOVER_IMAGE_ACTIONS.NONE,
      iconEnabledForComps: {},
    },
    props: {
      onClick,
      onDrop,
      image:
        'addPanelData/sections/blogArchiveSection_en/blogArchiveSection_en.png',
      imageHover: null,
      items: [
        {
          id: 'archive',
          structure: {
            layout: {
              x: 0,
              y: 0,
              fixedPosition: false,
              width: 254,
              height: 208,
              scale: 1,
              rotationInDegrees: 0,
            },
            type: 'Component',
            skin: 'wysiwyg.viewer.skins.TPAWidgetSkin',
            componentType: 'wysiwyg.viewer.components.tpapps.TPAWidget',
            data: {
              widgetId: WIDGET_ID,
              appDefinitionId: APP_DEF_ID,
              type: 'TPAWidget',
              metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false,
              },
              referenceId: '',
            },
            mobileHints: {
              type: 'MobileHints',
              hidden: true,
              metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false,
              },
            },
            style: 'tpaw0',
            connections: {
              type: 'ConnectionList',
              items: [],
              metaData: {
                isPreset: false,
                schemaVersion: '1.0',
                isHidden: false,
              },
            },
            activeModes: {},
          },
          preset: {
            rect: {
              width: 162,
              height: 97,
              x: 0,
              y: 0,
            },
            label: '',
            tags: null,
          },
        },
      ],
      compTypes: ['wysiwyg.viewer.components.tpapps.TPAWidget'],
    },
    help: { hide: false, text: 'add_section_info_text_newblog_archive' },
  };
}

export default {
  registerSection(editorAPI) {
    editorAPI.addPanel.registerSectionAtStart(
      addPanelDataConsts.CATEGORIES_ID.NEW_BLOG,
      _.partial(getSection, editorAPI),
    );
  },
};
